/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { resetUser, receiveToken, doInit } from '../actions/auth';
import axios from 'axios';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      username: '',
      password: '',
    };

  }
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  doReset=(e)=>{
    e.preventDefault();
    this.props.resetUser({ email: this.state.email});
  }
  changeEmail=(event)=> {
    this.setState({ email: event.target.value });
  }

  changeUsername=(event)=> {
      this.setState({ username: event.target.value });
  }

  changePassword=(event)=> {
      this.setState({ password: event.target.value });
  }
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <section className="section section-shaped section-lg">
            <div className="">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="pt-lg-7">
              <Row className="justify-content-center">
                <Col lg="5">
                  <Card className="bg-secondary shadow border-0">
                    
                    <CardBody className="px-lg-5 py-lg-4">
                      <div className="text-center text-muted mb-4">
                        Reset your Password
                      </div>
                      <Form role="form" onSubmit={this.doReset}>
                        <FormGroup className="mb-3">
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="Email" type="email"  value={this.state.email} onChange={this.changeEmail} />
                          </InputGroup>
                        </FormGroup>
                        
                        <div className="text-center">
                          <Button
                            // className="my-4"
                            color="primary"
                            type="submit"
                          >
                            Reset
                          </Button>
                          {
                            !this.props.auth.isFetching&&this.props.auth.errorMessage!=null&&
                            <p style={{color:'red', fontSize:'14px'}}>{this.props.auth.errorMessage}</p>
                          }
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    resetUser: (email)=>dispatch(resetUser(email)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Login);
